<template>
    <div class="sit-header">
        <h1 class="mx-auto col-11" v-if="code !== null && code !== undefined">Désolé ...</h1>

        <div v-else-if="loaded" class="mx-3 d-flex justify-content-between actions-block">
            <div class="d-flex">
                <div class="sit-form-category-btn mr-3">
                    {{ provider.category.label }}
                </div>
                <div class="page-title">
                    <span>
                    <router-link :to="'/summary/' + getB64(provider.provider.id)" class="mr-3">
                        {{ cardName }}
                    </router-link>
                    </span>
                    <div class="mr-3 d-flex" v-if="!readOnly">
                        <v-icon>keyboard_arrow_right</v-icon>
                        <span class="breadcrumb-item mr-3" :style="'color:' + updateColors.deep">
                <v-icon :color="updateColors.deep" large>edit_note</v-icon>
                            Brouillon
            </span>
                    </div>

                    <div v-else class="mr-3 d-flex">
                        <v-icon>keyboard_arrow_right</v-icon>
                        <span class="mr-3" style="color:black">
                            Informations
            </span>
                    </div>

<!--                    <div>-->
<!--                        <v-select-->
<!--                          :items="aspectsList"-->
<!--                          item-value="value"-->
<!--                          item-text="label"-->
<!--                          :disabled="!readOnly"-->
<!--                          v-model="aspect"-->
<!--                          @input="updateAspect"-->
<!--                          class="no-details"-->
<!--                          style="width: 150px"-->
<!--                          solo-->
<!--                          flat-->
<!--                        >-->
<!--                            <template #selection="{item}">-->
<!--                                <v-icon color="black" class="mr-2">{{item.icon}}</v-icon>{{item.label}}-->
<!--                            </template>-->
<!--                            <template #item="{item}">-->
<!--                                <v-icon color="black" class="mr-2">{{item.icon}}</v-icon>{{item.label}}-->
<!--                            </template>-->
<!--                        </v-select>-->
<!--                    </div>-->
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex" v-if="!readOnly && !$global.loading">
                    <v-btn class="custom-button-warning mr-3" outlined @click="saveDraft">
                        <v-icon left>save</v-icon>
                        Enregistrer
                    </v-btn>

                    <v-tooltip :color="updateColors.deep" bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="custom-button-warning mr-3" outlined @click="cancelDraft" v-on="on">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </template>
                        <div>
                            Annuler
                        </div>
                    </v-tooltip>

                    <v-tooltip :color="updateColors.deep" bottom v-if="hasDiffs && !$global.loading">
                        <template v-slot:activator="{ on }">
                            <v-btn class="custom-button-warning mr-3" outlined @click="displayDiffs" v-on="on">
                                <v-icon>visibility</v-icon>
                            </v-btn>
                        </template>
                        <div>
                            Modifications
                        </div>
                    </v-tooltip>
                </div>

                <v-btn class="custom-button-primary" outlined @click="prepareEdit()"
                       v-if="readOnly && draft === null && !$global.loading"
                       :disabled="$global.loading">
                    <v-icon left>edit_note</v-icon>
                    EDITER
                </v-btn>

                <v-btn class="custom-button-warning" outlined @click="continueEdit"
                       v-else-if="readOnly && draft !== null && !$global.loading">
                    <v-icon left>edit_note</v-icon>
                    BROUILLON EN COURS ({{ draft.user_first_name }} {{ draft.user_name }})
                    <span v-if="draft.aspect"> {{ displayAspectLabel(draft.aspect) }}</span>
                </v-btn>

                <v-btn class="custom-button-primary" outlined @click="publishDraft"
                       v-else-if="!$global.loading && draft !== null">
                    <v-icon left>published_with_changes</v-icon>
                    PUBLIER
                </v-btn>
            </div>
        </div>

        <div v-else class="mx-auto col-11">
            <content-placeholders class="d-flex justify-content-between">
                <content-placeholders-heading class="place-holder-title-xs" style="width: 400px; height: 51px" />
                <content-placeholders-img class="place-holder-title-lg ml-3" style="width: 150px; height: 80px">
                </content-placeholders-img>
            </content-placeholders>
        </div>

        <v-dialog v-model="takeDraftModal" width="700px" v-if="draft !== null">
            <take-power-back-modal :draft="draft"></take-power-back-modal>
        </v-dialog>

        <v-dialog ref="dialog" v-model="diffsModal" persistent max-width="1200px" fullscreen scrollable>
            <v-card>
                <v-card-title class="bg-primary w-100">
                    <div class="d-flex justify-content-between w-100">
                        <div class="text-white">
                            <h5 class="ml-2" style="min-width: 400px; ">
                                Modifications en cours
                            </h5>
                        </div>

                        <div class="text-right w-100">
                            <v-btn icon dark @click="diffsModal = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>

                <v-card-text class="h-100">
                    <sit-answer-diffs-step
                      :languages="languages">
                    </sit-answer-diffs-step>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import SitAnswerDiffsStep from "../../../webform/sit-answer-steppers/SitAnswerDiffsStep.vue"
import TakePowerBackModal from "../../../tools/TakePowerBackModal.vue"
import Confirm from "../../../tools/Confirm.vue"
import { aspectElements } from "../../../../static/webform"

export default {
    name: "SitFormHeader",
    components: { SitAnswerDiffsStep, TakePowerBackModal, Confirm },
    props: ["code", "loaded", "draft"],
    data() {
        return {
            takeDraftModal: false,
            diffsModal: false,
            languages: [],
            aspectsList: [
                {
                    label: 'Standard',
                    value: null,
                    icon: 'ballot',
                },
                {
                    label: 'Affaires',
                    value: 'business',
                    icon: 'business_center',
                },
                {
                    label: 'Eté',
                    value: 'summer',
                    icon: 'sunny',
                },
                {
                    label: 'Hiver',
                    value: 'winter',
                    icon: 'ac_unit',
                },
            ],
        }
    },
    methods: {
        ...mapMutations("web_form", ["setReadOnly", "setAspect"]),
        ...mapMutations("sitAnswer", ["setDiffs"]),
        prepareEdit(originAnswerId = null) {
            let payload = {
                userId: this.user.id,
                aspect: this.aspect,
                providerId: this.$route.params.providerId,
                contact: {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    email: this.user.email,
                },
                data: this.provider,
                originAnswerId: originAnswerId,
            }

            this.$global.loading = true

            this.$http.post("sitform/create-draft", payload).then(res => {
                if (res.body.success) {
                    this.setReadOnly(false)
                    this.emitFormatProvider(res)
                } else {
                    setTimeout(() => {
                        this.$global.loading = true
                        this.setReadOnly(true)
                        if (this.$route.query.fromAnswer) {
                            this.reloadProvider(this.$route.query.providerDataId, this.aspect)
                        } else {
                            this.reloadProvider()
                        }
                    }, 1000)
                }
            })
        },
        continueEdit() {
            if (this.user.id === this.draft.user_id) {
                this.$global.loading = true
                this.setReadOnly(false)
                this.reloadProvider(this.draft.provider_data_id, this.draft.aspect)
            } else {
                this.takeDraftModal = true
            }
        },
        cancelDraft() {
            this.$refs.confirm.open(
              "Annuler vos modifications en cours ?", "Vos modifications ne seront pas enregistrées.",
              { backgroundTitle: "primary", confirmColor: "primary" },
            ).then((confirm) => {
                if (confirm) {
                    let payload = {
                        providerId: this.provider.provider.id,
                        userId: this.user.id,
                    }

                    this.$global.loading = true

                    this.$http.post("sitform/cancel-draft", payload).then(res => {
                        this.reloadProvider()
                        this.$global.loading = true

                        setTimeout(() => {
                            this.$global.loading = true
                            this.setReadOnly(true)
                        }, 2000)
                    })
                }
            })
        },
        saveDraft() {
            let payload = {
                webFormId: this.draft.web_form_id,
                provider: this.provider,
                providerId: this.provider.provider.id,
            }

            this.$global.loading = true

            this.$http.post("sitform/save-draft", payload).then(res => {
                if (res.body.success) {
                    this.$global.loading = false
                }
            })
        },
        publishDraft() {
            let payload = {
                webFormId: this.draft.web_form_id,
                provider: this.provider,
                providerId: this.provider.provider.id,
            }

            this.$global.loading = true

            this.$http.post("sitform/publish-draft", payload).then(res => {
                this.setReadOnly(true)
                this.reloadProvider()
            })
        },
        getB64(id) {
            return btoa(id)
        },
        reloadProvider(providerDataId = null, aspect = null) {
            this.$global.$emit("get-provider", providerDataId, aspect)
            this.$global.loading = true

            setTimeout(() => {
                this.$global.loading = true
                this.$global.$emit("init-opening-periods")
                this.$global.$emit("init-price-periods")
                this.$global.$emit("init-contacts")
                this.$global.loading = false
            }, 3000)
        },
        emitFormatProvider(res) {
            this.$global.loading = true
            this.$global.$emit("format-provider", res)

            setTimeout(() => {
                this.$global.loading = true
                this.$global.$emit("init-opening-periods")
                this.$global.$emit("init-price-periods")
                this.$global.$emit("init-contacts")
                this.$global.loading = false
            }, 3000)
        },
        displayDiffs() {
            this.$global.loading = true
            let payload = {
                data: this.provider,
                providerId: this.provider.provider.id,
            }

            this.$http.post("sitform/get-diffs", payload).then(res => {
                this.setDiffs(res.body.data.diffs)
                this.diffsModal = true
                this.$global.loading = false
            })
        },
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        displayAspectLabel(draftAspect) {
            return aspectElements.find(aspect => {
                return aspect.name === draftAspect
            }).label
        },
        updateAspect(aspect) {
            this.setAspect(aspect)
            this.reloadProvider(null, this.aspect)
        }
    },
    computed: {
        ...mapState("web_form", [
            "provider",
            "aspect",
            "contact",
            "readOnly",
            "generalTabDirty",
            "localisationTabDirty",
            "communicationTabDirty",
            "platformTabDirty",
            "specificTabDirty",
            "openingTabDirty",
            "pricesTabDirty",
            "contactsTabDirty",
            "mediasTabDirty",
            "cardName",
            "aspect",
        ]),
        ...mapState("sitAnswer", [
            "diffs",
            "updateColors",
        ]),
        ...mapState("account", ["user"]),
        hasDiffs() {
            return (this.diffs && this.diffs.length > 0) || this.generalTabDirty || this.localisationTabDirty ||
              this.communicationTabDirty || this.openingTabDirty || this.platformTabDirty || this.pricesTabDirty ||
              this.contactsTabDirty || this.mediasTabDirty || this.specificTabDirty
        },
    },
    created() {
        this.getLanguages()
        this.setAspect(null)

        this.$global.$on("prepare-edit", (originAnswerId = null) => {
            this.prepareEdit(originAnswerId)
        })

        this.$global.$on("close_take_power_back_modal", () => {
            this.takeDraftModal = false
        })
    },
    destroyed() {
        this.$global.$off("prepare-edit")
    },
}
</script>